import type { Transformer } from "@lexical/markdown";
import {
  $convertFromMarkdownString,
  $convertToMarkdownString,
} from "@lexical/markdown";
import type { EditorState, LexicalEditor } from "lexical";

/**
 * Serialize editor state to markdown string
 */
export function serializeToMarkdown(
  editorState: EditorState,
  transformers: Transformer[],
): string {
  let markdown = "";

  editorState.read(() => {
    markdown = $convertToMarkdownString(transformers);
  });

  return markdown;
}

/**
 * Deserialize markdown string to editor state
 */
export function deserializeFromMarkdown(
  markdown: string,
  editor: LexicalEditor,
  transformers: Transformer[],
): void {
  editor.update(() => {
    $convertFromMarkdownString(markdown, transformers);
  });
}

/**
 * Get text content from editor state (without markdown formatting)
 */
export function getTextContent(editorState: EditorState): string {
  let text = "";

  editorState.read(() => {
    const root = editorState._nodeMap.get("root");
    if (root) {
      text = root.getTextContent();
    }
  });

  return text;
}
